import popup from '../stores/PopupStore';

export const ERROR_DIRECTORIO_DE_PERSONAS = -10001;
export const ERROR_INTERNO_SERVICIO = -10002;
export const ERROR_DATOS_NO_COINCIDEN = -10003;
export const ERROR_PERMISO = -10004;
export const ERROR_RUT_INVALIDO = -10005;
export const ERROR_SERVICIO_FIRMA = -10100;
export const ERROR_SERVICIO_FIRMA_PARAMETROS = -10102;
export const ERROR_SERVICIO_FIRMA_ID_NOT_FOUND_VIMP = -10103;
export const ERROR_SERVICIO_FIRMA_ID_INVALIDO_VIMP = -10104;
export const ERROR_SERVICIO_FIRMA_PIN_INVALIDO_VIMP = -10105;
export const ERROR_SERVICIO_FIRMA_ALMACENAR_DOC_BIOFIRMA = -10853;
export const ERROR_SERIE_BLOQUEADO = -20006;
export const ERROR_SERIE_INVALIDO = -20007;
export const ERROR_SERIE_NO_VIGENTE = -20008;
export const ERROR_CARGAR_REGIONES = -40001;
export const ERROR_CARGAR_COMUNAS = -40002;
export const ERROR_SERIE_EXISTE = -60001;
export const CERTIFICADO_NO_DISPONIBLE = -80001;
export const ERROR_GENERICO = -999999;

function errorGeo(codError) {
  let mensaje = '';
  switch (codError) {
    case ERROR_CARGAR_REGIONES:
      mensaje = 'Ocurrió un error al cargar el listado de regiones.';
      break;
    case ERROR_CARGAR_COMUNAS:
      mensaje = 'Ocurrió un error cargando el listado de comunas de tu región.';
      break;
    case ERROR_SERIE_EXISTE:
      mensaje = 'El número de serie/documento ingresado ya existe en el sistema.';
      break;
    default:
      mensaje = 'Error desconocido.';
  }
  popup.setPopupData({
    message: mensaje,
    btns: [{ label: 'aceptar', full: true, css: 'btn-morado', close: true }],
  });
  popup.showPopup();
}
function errorDirectorioPersonas() {
  popup.setPopupData({
    message: 'No fue posible encontrar tus datos en el directorio de personas',
    btns: [{ label: 'aceptar', full: true, css: 'btn-morado', close: true }],
  });
  popup.showPopup();
}

function errorCertificadoNoDisponible() {
  popup.setPopupData({
    message: 'El certificado de tu solicitud no esta disponible en este momento.',
    btns: [{ label: 'aceptar', full: true, css: 'btn-morado', close: true }],
  });
  popup.showPopup();
}

function errorDatosNoCoinciden() {
  popup.setPopupData({
    message: 'El rut o número de serie ingresado no se corresponde con lo almacenado en nuestra base de datos, por favor actualiza tus datos',
    btns: [{ label: 'aceptar', full: true, css: 'btn-morado', close: true }],
  });
  popup.showPopup();
}

function errorValidacionSerie(codError) {
  let mensaje = '';
  switch (codError) {
    case ERROR_SERIE_BLOQUEADO:
      mensaje = 'Documento de identidad se encuentra bloqueado.';
      break;
    case ERROR_SERIE_INVALIDO:
      mensaje = 'Número de serie/documento ingresado no es válido.';
      break;
    case ERROR_SERIE_NO_VIGENTE:
      mensaje = 'Número de documento no se encuentra vigente.';
      break;
    default:
      mensaje = 'Error desconocido.';
  }
  popup.setPopupData({
    message: mensaje,
    btns: [{ label: 'aceptar', full: true, css: 'btn-morado', close: true }],
  });
  popup.showPopup();
}

export function errorGenerico() {
  popup.setPopupData({
    message: 'en estos momentos no podemos atenderte, por favor acércate a cualquiera de nuestros centros de servicio ubicados en tiendas ripley o sucursales banco ripley para completar el proceso',
    btns: [{ label: 'aceptar', close: true, full: true, css: 'btn-morado' }],
  });

  popup.showPopup();
}

export function showErrorSinOfertas() {
  popup.setPopupData({
    message: 'Lo sentimos, no tenemos una oferta disponible para la combinación de productos que seleccionaste.',
    btns: [
      {
        label: 'aceptar',
        close: true,
        full: true,
        css: 'btn-morado',
      },
    ],
  });
  popup.showPopup();
}

export function showSessionInvalida() {
  popup.setPopupData({
    message: 'Has superado el tiempo maximo de sesion, por favor vuelve a ingresar.',
    btns: [
      {
        label: 'aceptar',
        close: false,
        action: () => {
          window.location.reload();
        },
        full: true,
        css: 'btn-morado',
      },
    ],
  });
  popup.showPopup();
}

export function showErrorCaptcha() {
  popup.setPopupData({
    message: 'No hemos podido validar correctamente que no eres un robot.',
    btns: [
      {
        label: 'aceptar',
        close: false,
        action: () => {
          window.location.reload();
        },
        full: true,
        css: 'btn-morado',
      },
    ],
  });
  popup.showPopup();
}

export function showErrorFirmaPin(numero) {
  popup.setPopupData({
    message: 'El PIN ingresado no es válido, revisa el código enviado por SMS al número '+numero+'.',
    btns: [
      {
        label: 'aceptar',
        close: true,
        full: true,
        css: 'btn-morado',
      },
    ],
  });
  popup.showPopup();
}

export function showErrorFirma(solicitudId) {
  popup.setPopupData({
    message: 'Por favor, vuelve a intentar en unos minutos, ingresando a la solicitud recientemente creada ('+solicitudId+').',
    btns: [
      {
        label: 'aceptar',
        close: true,
        full: true,
        css: 'btn-morado',
      },
    ],
  });
  popup.showPopup();
}

export function showErrorFor(code) {
  switch (code) {
    case CERTIFICADO_NO_DISPONIBLE:
      errorCertificadoNoDisponible();
      break;
    case ERROR_DIRECTORIO_DE_PERSONAS:
      errorDirectorioPersonas();
      break;
    case ERROR_SERIE_NO_VIGENTE:
      errorValidacionSerie(code);
      break;
    case ERROR_DATOS_NO_COINCIDEN:
      errorDatosNoCoinciden();
      break;
    case ERROR_SERIE_INVALIDO:
      errorValidacionSerie(code);
      break;
    case ERROR_CARGAR_REGIONES:
      errorGeo(code);
      break;
    case ERROR_GENERICO:
      errorGenerico();
      break;
    default:
      errorGenerico();
  }
}
